<template>
  <Wizzard
    ref="wizzardRef"
    title="Add Private Security or Other"
    name="Private Security or Other"
    :modal
    :preset
    :steps
    :transaction-type="TRANSACTION_TYPE"
    :asset-classes-list="ASSET_CLASSES_LIST"
    :investment-strategies-list="INVESTMENT_STRATEGIES_LIST"
    allow-multiple-entities
    :handle-step-status
  >
    <template
      v-if="isMultiEntity"
      #[valuesSlot]
    >
      <PrivateFundValues :entities="wizardEntities" />
    </template>
  </Wizzard>
</template>

<script setup lang="ts">
import { computed, provide, useTemplateRef } from 'vue'

import { ModalClass } from '@types'
import { InputWizardPreset } from '../utils/types'
import {
  ASSET_CLASSES_LIST,
  ASSET_TYPE_EXCLUDES,
  INVESTMENT_STRATEGIES_LIST,
  STEPS_LIST,
  TRANSACTION_TYPE,
} from './utils/const'

import Wizzard from '../components/Wizzard.vue'
import PrivateFundValues from '../PrivateFund/PrivateFundValues.vue'

type Props = {
  modal: ModalClass<any>
  preset?: InputWizardPreset
}

const { preset } = defineProps<Props>()

// Financials is a multi-entity-only step; drop it in single/preset mode.
const steps = computed(() =>
  preset ? STEPS_LIST.filter(step => step.name !== 'Financials') : STEPS_LIST,
)

provide('assetExcludes', ASSET_TYPE_EXCLUDES)

provide('assetDateLabel', 'Date of Investment')
provide('amountLabel', 'Cost of Investment')
provide('valuePlaceholder', 'Investment value')
provide('valueLabel', 'Valuation')

const wizzardRef = useTemplateRef('wizzardRef')

const isMultiEntity = computed(() => !preset)

const valuesSlot = computed(
  () => `step${steps.value.findIndex(step => step.name === 'Valuation') + 1}`,
)

const wizardEntities = computed(() => wizzardRef.value?.entities ?? [])

const isMultiValuationValid = computed(
  () =>
    isMultiEntity.value
      ? wizardEntities.value
        .some(entity => entity.prices.some(price => !!price.close))
      : false,
)
const handleStepStatus = (index: number) => {
  switch (steps.value[index]?.name) {
    case 'Valuation':
      return isMultiValuationValid.value
    default:
      return false
  }
}
</script>
